<template>
    <v-form-element :id="id" :label="label" :form="form" :input-name="inputName" :with-counter="withCounter" :max-length="maxLength" :container-class-name="containerClassName" :label-container-class-name="labelContainerClassName" :input-container-class-name="inputContainerClassName" :helper="helper">
        <codemirror :id="id" :class="className" v-model="model" :options="cmOptions" />
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement
        },
        props: {
            cmMode: {
                type: String,
                default: 'text/javascript'
            },
            cmTheme: {
                type: String,
                default: 'base16-300'
            },
            cmOptions: {
                type: Object,
                default() {
                    return {
                        tabSize: 4,
                        styleActiveLine: true,
                        lineNumbers: true,
                        line: true,
                        foldGutter: true,
                        styleSelectedText: true,
                        mode: this.cmMode,
                        theme: this.cmTheme
                    }
                }
            },
            className: {
                type: String,
                default: 'w-full text-gray-600 font-thin text-xl rounded border border-gray-300 hover:bg-white focus:bg-white focus:text-gray-700  hover:shadow focus:shadow focus:border-blue bg-gray-100 outline-none'
            }
        },
        mixins: [mixin]
    }
</script>
